<template>
    <div class="loader" role="status" aria-live="polite" aria-busy="true">
        <img :src="logo" alt="WealthPlanner logo" class="logo-spin" aria-hidden="true" />
        <span class="sr-only">Chargement…</span>
    </div>
</template>

<script>
import logo from '@/assets/images/lbf-icon.png'

export default {
    name: 'Loader',
    data() {
        return { logo }
    }
}
</script>

<style scoped>
.loader {
    position: fixed;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.7);
    z-index: 100000;
}

/* Logo + spin */
.logo-spin {
    height: 115px;
    width: 100px;
    animation: spin 1.6s linear infinite;
}

/* Accessibilité (texte masqué visuellement) */
.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
